<template>
  <!-- <div>
    <Tree :data="roleTree"></Tree>
    <role-detail ref="roledetail" :AllRoleList="rolelist"></role-detail>
      </div> -->
  <div class="content">
    <role-detail ref="roledetail" :AllRoleList="rolelist"></role-detail>
    <div class="fx__tree one" style="overflow:auto">
      <Tree :data="roleTree"></Tree>
    </div>
    <div class="two" style="overflow:auto">
      <textarea autocomplete="off" v-model="roleTreeJson" placeholder="" class="ivu-input" :class="{inputerror: isrepeatKey,colorerror:notjson}" style="height: 100%;"></textarea>
    </div>
    <!-- <div class="three">
      <textarea wrap="soft" autocomplete="off" spellcheck="false" v-model="parallel" placeholder="" class="ivu-input" style="height: 100%;"></textarea>
    </div> -->
  </div>

</template>

<script>
import roleDetail from "./detail"; //弹出框
import draggable from "./draggable"; //排序

function compareRankID(a, b) {
  if (a.RankID != null && b.RankID != null) {
    return parseInt(a.RankID) - parseInt(b.RankID);
  } else if (a.RankID != null && b.RankID == null) {
    return -1;
  } else if (a.RankID == null && b.RankID != null) {
    return 1;
  } else {
    return 0;
  }
}

function sortCondition(a, b) {
  //如果a<b return -1;
  //如果a>b return 1;
  if (a.UserID && b.UserID) {
    return compareRankID(a, b);
  } else if (a.UserID && !b.UserID) {
    return 1;
  } else if (!a.UserID && b.UserID) {
    return -1;
  } else {
    return compareRankID(a, b);
  }
}

export default {
  components: {
    roleDetail,
    draggable
  },
  props: {
    Opts: Object,
    ShowBotton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      rolelist: [],
      roleSelectedGID: null,
      expandDict: {},
      isDetail: false,
      isrepeatKey: false,
      notjson: false,
      treejsonTxt: "",
      treeStyle: {
        display: "inline-block",
        height: "24px",
        "padding-left": "6px",
        margin: 0,
        "line-height": "24px",
        width: "95%"
      }
    };
  },
  watch: {
    roleSelectedGID: function(newVal, oldVal) {
      //点击时改变，判断是否选中
      let _this = this;
      let selectedItem;
      if (newVal == null) selectedItem = null;
      else selectedItem = _this.rolelist.find(p => p.GID == newVal);
      this.$emit("on-selected", selectedItem);
    },
    "Opts.treeobj": function(newVal, oldVal) {
      let toList = this.treeToList(newVal);
      this.rolelist = toList;
    }
  },
  computed: {
    parallel: function() {
      let change = [];

      this.rolelist.forEach(p => {
        let changeItem = {};
        changeItem.text = p.GroupName;
        changeItem.name = p.RoleKey;
        change.push(changeItem);
      });
      return JSON.stringify(change, null, 2);
    },
    roleTreeJson: {
      get: function() {
        let _this = this;

        if (_this.notjson) {
          _this.Opts.treejson = null;
          return _this.treejsonTxt;
        }
        let _Treedata = _this.rolelist.List2Tree(
          "GID",
          "PGID",
          (ent, sublist) => {
            //将数据根据,"GID", "PGID"转换成树形结构
            //监听折叠展开
            let item = {
              text: ent.GroupName
            };
            if (ent.RoleKey) item.name = ent.RoleKey;
            item.children = sublist;
            return item;
          }
        );
        let json = JSON.stringify(_Treedata, null, 2);
        if (_this.isrepeatKey) {
          _this.Opts.treejson = null;
        } else 
          _this.Opts.treejson = json;

        return json;
      },
      set: function(newValue, oldValue) {
        //1、第一步先转为数组
        let _this = this;
        let tree;
        try {
          tree = JSON.parse(newValue);
        } catch (error) {
          _this.isrepeatKey = true;
          _this.notjson = true;
          _this.treejsonTxt = newValue;

          return;
        }
        _this.notjson = false;
        let toList = this.treeToList(tree);

        let resGroupArr = toList.GroupBy(p => p.RoleKey);
        delete resGroupArr["undefined"];

        if (Object.values(resGroupArr).find(p => p.length > 1)) {
          _this.isrepeatKey = true;
        } else _this.isrepeatKey = false;

        this.rolelist = toList;
      }
    },
    roleTree: function() {
      let _this = this;
      let _tree = [];
      let _Treedata = _this.rolelist.List2Tree(
        "GID",
        "PGID",
        (ent, sublist) => {
          //将数据根据,"GID", "PGID"转换成树形结构
          //监听折叠展开
          let item = new Proxy(
            {
              expand: _this.expandDict[ent.GID] || false
            },
            {
              set: function(obj, prop, value) {
                obj[prop] = value;
                if (prop === "expand") {
                  _this.expandDict[obj.name] = value;
                }
                return true;
              }
            }
          );

          Object.assign(item, {
            title: ent.GroupName,
            RoleKey: ent.RoleKey,
            PGID: ent.PGID,
            name: ent.GID
          });
          item.children = sublist;
          item.render = _this.renderTreeItem;
          return item;
        }
      );
      // console.log(_Treedata )
      return [
        {
          title: "根节点",
          name: "all",
          children: _Treedata,
          // RoleType:'根节点',
          expand: true,
          render: _this.renderTopTreeItem
        }
      ];
    }
  },
  mounted() {},
  methods: {
    treeToList(arr) {
      //树形结构转平行结构
      let id = 0;
      let _this = this;
      let newArr = arr.Tree2List("children", (Id, ParentId, Item) => {
        let rowData = {};
        rowData.GID = Id;
        rowData.PGID = ParentId;
        rowData.GroupName = Item.text;
        rowData.RoleKey = Item.name;
        return rowData;
      });

      return newArr;
    },
    makeBtn(fn) {
      return {
        class: "ivu-btn ivu-btn-primary",
        style: {
          display: "inline-block",
          // width:"60px",
          float: "right",
          "line-height": "100%",
          "text-align": "center",
          height: "100%",
          marginRight: "5px"
        },
        on: {
          click(event) {
            event.stopPropagation();
            fn();
          }
        }
      };
    },
    renderTreeItem(h, { root, node, data }) {
      let _this = this;
      return h(
        "span",
        {
          class: {
            fx__item: true,
            "fx__item-selected": _this.roleSelectedGID == data.name
          },
          style: _this.treeStyle,
          on: {
            click() {
              if (data.children != undefined) data.expand = !data.expand;
            }
          }
        },
        [
          h(
            "span",
            {
              class: {
                roleTree__title: true,
                fx__tag: true
              },
              on: {
                click(event) {
                  event.stopPropagation();
                  //切换选中
                  if (_this.roleSelectedGID == data.name)
                    _this.roleSelectedGID = null;
                  else _this.roleSelectedGID = data.name;
                }
              }
            },
            data.RoleKey ? `${data.title}(${data.RoleKey})` : data.title
          ),
          _this.ShowBotton
            ? h(
                "span",
                {
                  class: "fx__opera"
                },
                [
                  data.children == undefined
                    ? h(
                        "button",
                        _this.makeBtn(() => {
                          // 用于渲染按钮 并传入点击按钮是应该要做什么
                          _this.deleteRole(data, root, node);
                        }),
                        [h("i", { class: "/*fa fa-trash*/" }), "删除"]
                      )
                    : "",
                  // : h(
                  //   "button",
                  //   _this.makeBtn(() => {

                  //     let groupArr = data.children.filter(
                  //       p => p.UserID === undefined
                  //     );
                  //     _this.updateorder(groupArr)
                  //     data.expand = true;
                  //   }),
                  //   [h("i", { class: "/*fa fa-trash*/" }), "排序"]
                  // ),
                  h(
                    "button",
                    _this.makeBtn(() => {
                      // _this.roleSelectedGID = data.name;
                      _this.editRole(data, this.rolelist).then(entity => {
                        //1、点击按钮触发 editRole() 并把data传过去
                        // _this.$Message.info("编辑完成");
                        //修改本节点信息
                        let item = _this.rolelist.find(p => p.GID == data.name);
                        if (entity.PGID === "all") {
                          entity.PGID = null;
                        }
                        item.PGID = entity.PGID;
                        item.GroupName = entity.GroupName;
                        item.RoleKey = entity.RoleKey;
                      });
                    }),
                    [h("i", { class: "/*fa fa-edit*/" }), "编辑"]
                  ),
                  h(
                    "button",
                    _this.makeBtn(() => {
                      _this.appendSubRole(data).then(entity => {
                        //把数据传过去 等待回调
                        // _this.$Message.info("添加完成");
                        data.expand = true;
                        _this.rolelist.push({
                          GID: entity.GID,
                          PGID: entity.PGID,
                          GroupName: entity.GroupName,
                          RoleKey: ""
                        });
                        _this.roleSelectedGID = entity.GID;
                      });
                    }),
                    [h("i", { class: "/*fa fa-plus*/" }), "添加"]
                  )
                ]
              )
            : ""
        ]
      );
    },
    renderTopTreeItem(h, { root, node, data }) {
      let _this = this;
      return h(
        "span",
        {
          class: "fx__item",
          style: _this.treeStyle,
          on: {
            click() {
              data.expand = !data.expand;
            }
          }
        },
        [
          h("span", {}, data.title),
          _this.ShowBotton
            ? h(
                "span",
                {
                  class: "fx__opera"
                },
                [
                  // h("button", _this.makeBtn(() => {}), [
                  //   h("i", { class: "fa fa-edit" }),
                  //   "编辑"
                  // ]),
                  // h(
                  //   "button",
                  //   _this.makeBtn(() => {
                  //     let groupArr = data.children.filter(
                  //       p => p.UserID === undefined
                  //     );
                  //     _this.updateorder(groupArr)
                  //     data.expand = true;
                  //   }),
                  //   [h("i", { class: "/*fa fa-trash*/" }), "排序"]
                  // ),
                  h(
                    "button",
                    _this.makeBtn(() => {
                      _this.createRole(data).then(entity => {
                        // _this.$Message.info("新增成功");
                        data.expand = true;
                        _this.rolelist.push(entity);
                        _this.roleSelectedGID = entity.GID;
                      });
                    }),
                    [h("i", { class: "/*fa fa-plus*/" }), "新增"]
                  )
                ]
              )
            : ""
        ]
      );
    },
    appendSubRole({ name, title }) {
      //解构data的name, title
      let _this = this;
      return new Promise(function(resolve, reject) {
        _this.$refs.roledetail.ShowAppendDlg({
          rowData: {
            PGID: name,
            PGroupName: title,
            RoleKey: null
          },
          title: "添加子角色",
          saveOkFn(entity) {
            resolve(entity);
          }
        });
      });
    },
    editRole({ name, title, RoleKey, PGID }) {
      // 2、把data的 name, title, RoleType, RoleKey, PGID 解构
      let _this = this;
      return new Promise(function(resolve, reject) {
        _this.$refs.roledetail.ShowEditDlg({
          rowData: {
            GID: name,
            PGID,
            GroupName: title,
            RoleKey
          },
          oldrolelist: _this.rolelist,
          title: "编辑角色",
          saveOkFn(entity) {
            resolve(entity);
          }
        });
      });
    },
    deleteRole(data, root, node) {
      let { name, title } = data;
      let _this = this;
      _this.$Modal.confirm({
        title: "删除确认",
        content: "<p>是否确认删除此角色,一旦删除不可恢复</p>",
        loading: true,
        onOk: () => {
          // setTimeout(() => {
          _this.$Modal.remove();
          // _this.$Message.info("删除完成");
          _this.rolelist.RemoveAll(function(item) {
            return item.GID == data.name;
          });
        }
      });
    },
    createRole({ name, title, PGID }) {
      let _this = this;
      return new Promise(function(resolve, reject) {
        _this.$refs.roledetail.ShowCreateDlg({
          rowData: {
            PGID: "",
            PGroupName: "",
            RoleKey: null
          },
          title: "新建角色",
          saveOkFn(entity) {
            resolve(entity);
          }
        });
      });
    }
    // sortSubRole(groupArr) {
    //   let _this = this;
    //   return new Promise(function (resolve, reject) {

    //     _this.$Modal.confirm({//render函数的弹出框
    //       title: "排序",
    //       render: h =>
    //         h(draggable, { props: { groupArr }, ref: "dragBox" }),
    //       onOk() {
    //         let dragDom = this.$refs.dragBox;

    //         let lstRoleRank = dragDom.groupRankArr.map((p, i) => ({
    //           RankID: i,
    //           GID: p.name
    //         }));
    //         _this.$curl
    //           .post("/api/core/userManager/saveRank", {
    //             content: JSON.stringify({
    //               lstUserRank: [],
    //               lstRoleRank,
    //             })
    //           })
    //           .then(res => {

    //             resolve(dragDom.newArr);
    //           });
    //       }
    //     });
    //   });
    // },
  }
};
</script>

<style lang="scss">
</style>


<style lang="scss" scoped>
.inputerror {
  border: 1px solid red !important;
}
.colorerror {
  color: red !important;
}
.content {
  user-select: none;
  display: flex;
  height: 100%;
  .one {
    flex: 1;
    height: calc(100%);
  }
  .two {
    flex: 1;
    height: calc(100%);
  }
  .three {
    flex: 1;
    height: calc(100%);
  }
}
</style>
